import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultProgramPage from './Pages/DefaultProgramPage';
import WizardPage from './Pages/WizardPage';

const MindfulnessProgramRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:coBrandID/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultProgramPage />
            </Route>
        </Switch>
    );
};

export default MindfulnessProgramRouter;
